'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Implement with Base UI Radio
import { forwardRef, useId } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
import { Icon } from "../Icon/index.js";
import { clickableLabelClasses, helperClasses, requiredClasses } from "../../common/classes.js";
const formClasses = cva([
    'flex',
    'flex-row',
    'items-start'
]);
const radioClasses = cva([
    'appearance-none',
    'cursor-pointer',
    'border-2',
    'rounded-full',
    'h-5',
    'w-5',
    'transition',
    'mt-0.5',
    'mr-2',
    'border-gray-200',
    'enabled:hover:border-gray-700',
    'accent-primary',
    'text-primary',
    'peer',
    'focus:outline-0',
    'focus:outline-offset-0',
    'focus-visible:outline',
    'focus-visible:outline-2',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-offset-transparent',
    'focus-visible:outline-primary',
    'checked:border-transparent',
    'enabled:hover:checked:border-transparent',
    'checked:bg-current',
    'shrink-0'
]);
const radioIconClasses = cva([
    'absolute',
    'hidden',
    'peer-checked:block',
    'w-2',
    'h-2',
    'mt-2',
    'ml-1.5',
    'pointer-events-none'
]);
/**
 * Radio - [API](https://scl.sharp.com/?path=/docs/base-radio) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#6fe5085e78274cffae78a4eca4fcc34f)
 */ const Radio = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { label, id, disabled = false, helperText, className } = _param, props = _object_without_properties(_param, [
        "label",
        "id",
        "disabled",
        "helperText",
        "className"
    ]);
    const generatedID = useId();
    const inputID = id !== null && id !== void 0 ? id : generatedID;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(formClasses({
            className
        })),
        children: [
            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, props), {
                ref: ref,
                type: "radio",
                id: inputID,
                disabled: disabled,
                className: cn(radioClasses({
                    className
                }))
            })),
            /*#__PURE__*/ _jsx(Icon, {
                icon: "circle",
                inverse: true,
                className: cn(radioIconClasses())
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            label && /*#__PURE__*/ _jsx("label", {
                                htmlFor: inputID,
                                className: cn(clickableLabelClasses({
                                    disabled
                                })),
                                children: label
                            }),
                            props.required && /*#__PURE__*/ _jsx("div", {
                                "aria-label": "required",
                                className: cn(requiredClasses({
                                    disabled
                                })),
                                children: "*"
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ _jsx("div", {
                        className: cn(helperClasses({
                            disabled
                        })),
                        children: helperText
                    })
                ]
            })
        ]
    });
});
export { Radio };
